/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Heading_LabelInputs */

const ja_work_heading_label = /** @type {(inputs: Work_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Work`)
};

const en_work_heading_label = /** @type {(inputs: Work_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Work`)
};

/**
* | output |
* | --- |
* | "Our Work" |
*
* @param {Work_Heading_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const work_heading_label = /** @type {((inputs?: Work_Heading_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Heading_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_work_heading_label(inputs)
	return en_work_heading_label(inputs)
});